import { Dialog, DialogContent, DialogTitle, Theme, makeStyles } from "@material-ui/core";
import { DsIcon, size } from "@mvp/design-system";
import React, { useEffect } from "react";
import { useAppStore, useBool } from "../../../hooks";
import { ModalContent } from "../../../store/enums/ModalContent";
import { Between26and29Content } from "./Between26and29Content";
import { CannotRetrieveBenefitsSummaryContent } from "./CannotRetrieveBenefitsSummaryContent";
import { EffectiveDateErrorContent } from "./EffectiveDateErrorContent";
import { LifeEventContent } from "./LifeEvent";
import { OverSixtyFiveContent } from "./OverSixtyFiveContent";
import { PlanNotFoundContent } from "./PlanNotFoundContent";
import { SubmissionErrorContent } from "./SubmissionErrorContent";
import { ThirtyAndOver } from "./ThirtyAndOver";
import { UnderNineteenContent } from "./UnderNineteenContent";

interface EnrollNowModalProps {
  showCloseButton?: boolean;
}

const useStyles = makeStyles<Theme, EnrollNowModalProps>((theme) => ({
  paper: {
    borderRadius: '1.25rem',
    maxWidth: "45.25rem"
  },
  modalTitle: {
    padding: `${size.xs(theme)} 1.5rem 0`,
    textAlign: 'right'
  },
  modalContent: {
    padding: (props) => `${props.showCloseButton ? '0' : '1.8125rem'} 5rem 2.5rem !important`,
    [theme.breakpoints.down('sm')]: {
      padding: (props: any) => `${props.showCloseButton ? '0' : '1.8125rem'} 3rem ${size.l(theme)} !important`,
    }
  },
  iconStyles: {
    cursor: 'pointer'
  }
}));

const EnrollNowModal: React.FC<EnrollNowModalProps> = ({ showCloseButton = true }) => {
  const classes = useStyles({ showCloseButton });
  const { appStore: { modalContent }, appStoreDispatch } = useAppStore();
  const { bool: showDialog, setBool } = useBool(false);

  useEffect(() => {
    if (modalContent !== ModalContent.Empty) {
      setBool(true);
    }

  }, [modalContent]);

  const closeDialog = () => {
    setBool(false);
    setTimeout(() => appStoreDispatch('setModalContent', ModalContent.Empty), 2);
  };

  const Content = getModalContent(modalContent);

  return (
    <Dialog open={showDialog} classes={{ paper: classes.paper }}>
      <DialogTitle classes={{ root: classes.modalTitle }}>
        {showCloseButton && <DsIcon icon="fal fa-times" title="Close Button" onClick={closeDialog} className={classes.iconStyles} />}
      </DialogTitle>
      <DialogContent classes={{ root: classes.modalContent }}>
        <Content />
      </DialogContent>
    </Dialog>
  );
};

const getModalContent = (content: ModalContent) => {
  return {
    [ModalContent.Over65]: OverSixtyFiveContent,
    [ModalContent.Between26and29]: Between26and29Content,
    [ModalContent.ThirtyAndOver]: ThirtyAndOver,
    [ModalContent.Under19]: UnderNineteenContent,
    [ModalContent.LifeEvent]: LifeEventContent,
    [ModalContent.PlanNotFound]: PlanNotFoundContent,
    [ModalContent.SubmissionError]: SubmissionErrorContent,
    [ModalContent.EffectiveDateError]: EffectiveDateErrorContent,
    [ModalContent.CannotRetrieveBenefitsSummary]: CannotRetrieveBenefitsSummaryContent,
    [ModalContent.Empty]: () => <></>,
  }[content]
}

export default EnrollNowModal;